// React
import React from 'react';
// External
import {
    Container, Form
} from 'react-bootstrap';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import isNil from 'lodash/isNil';
// Internal
import NavbarPrimary from 'components/shared/organisms/NavbarPrimary/NavbarPrimary';
import NavbarSecondary from 'components/shared/organisms/NavbarSecondary/NavbarSecondary';
import PageTitleWithCart from 'components/shared/molecules/PageTitleWithCart/PageTitleWithCart';
import ContentCard from 'components/shared/organisms/ContentCard/ContentCard';
import FooterBtnActions from 'components/shared/molecules/FooterBtnActions/FooterBtnActions';
import Stepper from 'components/shared/atoms/Stepper/Stepper';
import BookingSubmitted from 'components/new-booking/BookingSubmitted/BookingSubmitted';
import BookingDetails from 'components/new-booking/BookingDetails/BookingDetails';
import AlertDismissible from 'components/shared/atoms/AlertDismissible/AlertDismissible';
import {
    updateBooking,
    clearBooking
} from 'stores/actions';
import {
    createBooking, completeBooking, addSpecialInstruction, getBooking, editBooking
} from 'services/booking';
// Constants
import REFERRAL_STEPS from 'constants/privateReferralSteps';
// Styles
import './styles.scss';
// Models
import Owner from 'models/Owner';
import Pet from 'models/Pet';
import Booking from 'models/Booking';
import VetService from 'services/vet';
import PageTitle from 'components/shared/atoms/PageTitle/PageTitle';
import OwnerPetDetailsForm from 'components/new-booking/OwnerPetDetailsForm/OwnerPetDetailsForm';
import SpecialInstructions from 'components/new-booking/SpecialInstructions/SpecialInstructions';
import { isEmptyObject } from 'jquery';
import config from 'config/config';
import Pusher from 'pusher-js';
import isEmpty from 'lodash/isEmpty';
import { logErrorToAtatus } from 'services/atatus';

const DEFAULT_ERROR_MSG = "Something went wrong. Please verify the information and try again.";
const DISPERSAL_SERVICE_TYPE_NAME = 'private cremation & dispersal of ashes';

class PrivateCremation extends React.Component {
    constructor(props) {
        super(props);
        // check url
        const isEdit = this.props.match.path === '/edit-booking-referral/:id' ? true : false;
        this.isAshesDispersalServiceType = false;
        this.ashesDespersalServiceTypeName = '';
        this.checkIfAshesDispersalServiceType();

        this.state = {
            headerTitle: '',
            owner: Owner(this.props.booking.owner),
            pet: Pet(this.props.booking.pet),
            bookingId: '',
            steps: this.getStepsArray(),
            isSubmitted: false,
            isLoading: false,
            vetDetails: null,
            alertFail: {
                show: false,
                message: DEFAULT_ERROR_MSG,
            },
            skip: false,
            isEdit: isEdit,
            isBookingLoaded: false,
            bookingImage: '',
            ownerPetDetailsDisabled: false,
            isVetDirect: false,
            isUnsubmitted: true,
            petWeightEditable: false,
        };
        this.ownerPetformComponent = {
            owner: React.createRef(),
            pet: React.createRef()
        };
        this.formComponentSecondary = React.createRef();
        this.bookingDetailsRef = React.createRef();
        // if edit, get booking details
        if (isEdit) {
            this.getBookingDetails();
        } else {
            this.state.isBookingLoaded = true;
        }
    }

    componentDidMount() {
        this.updateStepData();
        if (!this.state.isEdit) {
            this.getVetDetails();
        } else {
            localStorage.removeItem('is-pet-next');
        }
    }

    componentDidUpdate(prevProps) {
        this.updateStepData();
        // set owner and pet details if booking is updated
        if ((prevProps.booking !== this.props.booking) && this.state.isEdit && !this.state.isBookingLoaded) {
            this.subscribeToPusher();
            // get booking image
            this.props.booking.getImage().then((response) => {
                if (!isEmptyObject(response.data)) {
                    this.setState({bookingImage: response.data});
                }
            });
            // get vet relationship type
            VetService.getVetDetails().then((response) => {
                let isVetDirect = false;
                if (response.data.cstm.relationship_type_c === "vet_direct") {
                    isVetDirect = true;
                }
                this.setState({isVetDirect}, () => {
                    this.props.booking.owner.phoneNumber = this.props.booking.owner.phoneNumber.replace("+61", "0");
                    if (this.props.booking.skipOwnerDetails === null) {
                        this.props.booking.skipOwnerDetails = response.data.cstm.provides_client_details_c == 0 ? 1 : 0;
                    }
                    this.setState({ petWeightEditable: this.props.booking.pet.weight === "" ? true : false, owner: this.props.booking.owner, pet: this.props.booking.pet, isBookingLoaded: true, skip: this.props.booking.skipOwnerDetails == 1 ? true : false, vetDetails: response.data, isUnsubmitted: this.props.booking.parsedOrderStage?.includes('Unsubmitted')}, () => {
                        if (this.props.booking.parsedOrderStage.includes("Submitted") || this.props.booking.parsedOrderStage.includes("In Progress")) {
                            this.setState({ownerPetDetailsDisabled: true});
                        }
                    });
                });
            });
        }
    }

    componentWillUnmount() {
        if (this.channel) {
            // Unsubscribe from Pusher channel
            this.channel.unsubscribe();
        }
    }

    /**
     * [getBookingDetails get booking details]
     *
     */
    getBookingDetails() {
        getBooking(this.props.match.params.id)
            .then((response) => {
                const booking = Booking(response.data);
                this.props.updateBooking({...booking});
            }).catch((err) => {
                console.error('err :>> ', err);
            });
    }

    getBookingOptionName() {
        return this.props.booking.id ? this?.props?.booking?.serviceType?.name : this?.props?.booking?.bookingOptionSelected?.label
    }

    /**
     * Submit the form based on the async form component submit
     * @todo Add submit information request
     */
    async onSubmit() {
        try {
            this.setState({ isLoading: true });
            // Gets the data about the current form step
            const currentStepIndex = this.getCurrentStepIndex();
            const currentStepName = this.state.steps[currentStepIndex].name;

            if (this.state.isSubmitted) {
                this.props.history.push(`/booking/${this.state.bookingId}`);
            } else if (currentStepName === REFERRAL_STEPS.ownerPetDetails.name) {
                // handles the submission of the form of the current step
                // based on the referral cremation steps
                // Saves the owner information enter on the form to continue with the pet information
                let ownerData;

                // Only save the owner details if the skip checkbox is not ticked
                if (!this.state.skip) {
                    ownerData = await this.saveOwnerDetails();
                }

                // Saves the pet information
                const petData = await this.savePetDetails();

                // Go to next step after saving the owner and pet information
                if ((ownerData || this.state.skip) && petData) {
                    await this.props.updateBooking({ skipOwnerDetails: this.state.skip });

                    // The booking is created once the owner details and pet details are filled
                    try {
                        await this.submitBooking();
                        localStorage.setItem('is-pet-next', true);
                        // Go to next step after saving the booking information
                        this.navigateNext();
                    } catch (error) {
                        logErrorToAtatus(`Failed to submit booking at ${this.getBookingOptionName()}`, {
                            ...error, 
                            message: error.message, 
                            booking_id: this.props.booking.id, 
                            booking_number: this.props.booking.orderId
                        })

                        await this.setState({
                            alertFail: {
                                ...this.state.alertFail,
                                show: true,
                            },
                            isLoading: false
                        });
                    } finally {
                        this.setState({ isLoading: false });
                    }
                } else {
                    await this.setState({ isLoading: false });
                }
            } else if (currentStepName === REFERRAL_STEPS.confirmation.name) {
                if (this.props.booking.id) {
                    try {
                        // Get the screenshot image of the booking details
                        const screenshot = await this.bookingDetailsRef.current.getImage();
                        if (this.state.isUnsubmitted) {
                            await completeBooking(this.props.booking.id, {
                                screenshotImage: screenshot,
                            });
                            // remove temporary booking flag when booking is complete
                            await localStorage.removeItem('createBookingFlag')
                        }
                        localStorage.setItem('is-pet-next', true);
                        this.setState({ isSubmitted: true, bookingId: this.props.booking.id });
                        this.props.clearBooking();
                    } catch (error) {
                        logErrorToAtatus(`Failed to submit booking at ${this.getBookingOptionName()}`, {
                            ...error, 
                            message: error.message, 
                            booking_id: this.props.booking.id, 
                            booking_number: this.props.booking.orderId
                        })

                        await this.setState({
                            alertFail: {
                                show: true,
                                message: "Error: " + (!isNil(error?.response?.data?.errors?.detail) ? error.response.data.errors.detail : DEFAULT_ERROR_MSG),
                            },
                            isLoading: false
                        });
                    } finally {
                        this.setState({ isLoading: false });
                    }
                } else {
                    await this.setState({ isLoading: false });
                }
            } else {
                // Products can click on next without verification
                this.navigateNext();
                await this.setState({ isLoading: false });
                localStorage.setItem('is-pet-next', true);
            }
        } catch (error) {
            logErrorToAtatus(`Failed to submit booking at ${this.getBookingOptionName()}`, {
                ...error, 
                message: error.message, 
                booking_id: this.props.booking.id, 
                booking_number: this.props.booking.orderId
            })

            this.setState({ isLoading: false });
        }
    }

    /**
     * Retrieves the vet details
     */
     getVetDetails = () => {
        VetService.getVetDetails()
            .then((response) => {
                // set skip
                this.setState({ skip: response.data.cstm.provides_client_details_c == 0 ? true : false, vetDetails: response.data })
                this.ownerPetformComponent.owner.current.handleCheckbox(this.state.skip);
            }).catch((err) => {
                console.error(err);
            });
    }

    getStepsArray = () => {
        return Object.keys(REFERRAL_STEPS).map(
            (key) => REFERRAL_STEPS[key]
        );
    }

    /**
     * @returns the current index step
     */
    getCurrentStepIndex() {
        const currentStepHash = this.props.location.hash;
        for (const [index, step] of this.state.steps.entries()) {
            if (step.hash === currentStepHash) {
                return index;
            }
        }
        return null;
    }

    // Validates and stores the owner data from the form
    async saveOwnerDetails() {
        const owner = await this.ownerPetformComponent.owner.current.handleSubmit();

        if (owner) {
            const pet = Pet({ lastName: owner.lastName });
            this.setState({ owner: Owner(owner), pet });
            this.props.updateBooking({ owner: Owner(owner), pet });
            return owner;
        }
        return null;
    }

    // Validates and stores the pet data from the form
    async savePetDetails() {
        const pet = await this.ownerPetformComponent.pet.current.handleSubmit();
        if (pet) {
            this.setState({ pet: Pet(pet) });
            this.props.updateBooking({ pet: Pet(pet) });
            return pet;
        }
        return null;
    }

    /**
     * Submits the booking with the owner and the pet information
     */
    async submitBooking() {
        if (this.state.pet && this.state.owner) {
            const booking = Booking({
                ...this.props.booking,
                pet: this.state.pet,
                owner: this.state.owner
            });

            // Submits the booking request
            const response = this.props.booking.id ? await editBooking(this.props.booking.id, booking.submitFormat()) : await createBooking(booking.submitFormat());
            const bookingData = Booking(response.data);
            // After the booking being created the special instructions are submitted
            const specialInstructions = await this.submitSpecialInstructions(bookingData.id);
            // Update booking data in store
            this.props.updateBooking({ ...bookingData, ...specialInstructions });
            localStorage.setItem('bookingName', `${this.props.booking.orderId} ${this.props.booking.pet.firstName} ${this.props.booking.pet.lastName}`);
        }
    }

    /**
     * Submits the special instructions one by one (due to the Sugar API endpoints)
     * @param {string} bookingId
     */
     async submitSpecialInstructions(bookingId) {
        let specialInstructions = await this.formComponentSecondary.current.handleSubmit();
        if (specialInstructions && bookingId) {
            specialInstructions = specialInstructions.filter((item) => item);
            const response = await addSpecialInstruction(bookingId, specialInstructions);
            const booking = Booking({ specialInstructions: response.data });
            return { specialInstructions: booking.specialInstructions };
        }
        return { specialInstructions: [] };
    }

    navigateTo(path) {
        this.props.history.push(path);
        window.scrollTo(0, 0);
    }

    /**
     * Navigate to dashboard on cancel
     * @todo verify if you can leave the page
     */
    navigateCancel() {
        this.navigateTo('/dashboard');
    }

    /**
     * Handler to navigate to the next form after submitting the form,
     * it navigates to the next based on the current step
     */
    navigatePrev() {
        const currentStepHash = this.props.location.hash;
        let currentStepIndex = 0;
        this.state.steps.forEach((step, index) => {
            if (step.hash === currentStepHash) currentStepIndex = index;
        });
        if (currentStepIndex === 0) {
            // Navigates to new booking page if the current step is the initial
            this.navigateTo('/new-booking');
        } else if (currentStepIndex > 0) {
            // Navigates to the previous step
            const prevStep = currentStepIndex - 1;
            this.navigateTo(this.state.steps[prevStep].hash);
        }
    }

    /**
     * Handler to navigate to the next form after submitting the form,
     * it navigates to the next based on the current step
     */
    navigateNext() {
        const currentStepIndex = this.getCurrentStepIndex();
        const nextStep = currentStepIndex + 1;
        if (nextStep < this.state.steps.length) {
            this.navigateTo(this.state.steps[nextStep].hash);
        }
    }

    /**
     * Subscribe to Pusher
     */
    subscribeToPusher () {
        // get user data
        const userData = JSON.parse(localStorage.getItem('userData'));
        const userId = userData.id;
        // init pusher
        const pusher = new Pusher(
            config.PUSHER.key,
            {
                cluster: config.PUSHER.cluster,
                forceTLS: true,
                authEndpoint: config.PUSHER.presence_endpoint,
                auth: {
                    params: {
                        id: userId,
                        type: 'contact',
                    }
                }
            }
        )
        // subscribe to Pusher channel
        this.channel = pusher.subscribe('presence-' + this.props.booking.id);
    }

    /**
     * Updates the data of the current step based on the constant variable of the new booking steps
     */
    updateStepData() {
        const stepHash = this.props.location.hash;

        // If the hash is not define then navigates to the first step
        if (!stepHash) this.navigateTo(REFERRAL_STEPS.ownerPetDetails.hash);

        // Updates the information of the current step
        Object.keys(REFERRAL_STEPS).forEach((key, index) => {
            if (REFERRAL_STEPS[key].hash === stepHash) {
                const totalSteps = Object.keys(REFERRAL_STEPS).length;
                const title = `Step ${index + 1} of ${totalSteps} - ${REFERRAL_STEPS[key].title}`;

                // If the current headerTitle state has change then is updated
                if (this.state.headerTitle !== title) {
                    this.setState({ headerTitle: title });
                }
            }
        });
    }

    /**
     * Returns subcomponent be displayed on the current step of the new booking
     */
     headerSubcomponentView() {
        const stepHash = this.props.location.hash;
        if (stepHash === REFERRAL_STEPS.ownerPetDetails.hash) {
            return (
                <div className="skip-checkbox">
                    <h3 className='step-title header-margin'>{this.state.headerTitle}</h3>
                    <div className="form-header">Owner Details</div>
                    <Form.Check
                        type="checkbox"
                        id="skip-checkbox"
                        label="Do not provide owner details"
                    >
                        <Form.Check.Input
                            type="checkbox"
                            name="skip"
                            onChange={(event) => {
                                this.setState({ skip: event.target.checked });
                                this.ownerPetformComponent.owner.current.handleCheckbox(event.target.checked);
                            }}
                            disabled={this.state.ownerPetDetailsDisabled}
                            checked={this.state.skip}
                        />
                        <Form.Check.Label>
                            Do not provide owner details
                            <span>If selected, owner details will be excluded from this booking</span>
                        </Form.Check.Label>
                    </Form.Check>
                </div>
            );
        }

        return null;
    }

    /**
     * Returns the form to be displayed on the current step of the new booking
     */
    stepFormView() {
        const stepHash = this.props.location.hash;
        switch (stepHash) {
            case REFERRAL_STEPS.ownerPetDetails.hash:
                return (
                    <div>
                        <OwnerPetDetailsForm
                            formComponent={this.ownerPetformComponent}
                            formData={{
                                owner: this.state.owner,
                                pet: this.state.pet,
                                bookingImage: this.state.bookingImage
                            }}
                            hideForm={this.state.skip}
                            ownerPetDetailsDisabled={this.state.ownerPetDetailsDisabled}
                            isEdit={this.state.isEdit}
                            petWeightEditable={this.state.petWeightEditable}
                        />
                        <hr />
                        <SpecialInstructions
                            ref={this.formComponentSecondary}
                            specialInstructions={this.props.booking.specialInstructions}
                            ownerPetDetailsDisabled={this.state.ownerPetDetailsDisabled}
                        />
                    </div>
                );
            case REFERRAL_STEPS.confirmation.hash:
                return (
                    <div className="booking-confirm-container">
                        <BookingDetails booking={this.props.booking} vetDetails={this.state.vetDetails} headerTitle={this.state.headerTitle} ref={this.bookingDetailsRef} />
                    </div>
                );
            default:
                return null;
        }
    }

    /**
     * Checks if the current service type is the ashes dispersal service type.
     * Retrieves the service type name from the existing booking or local storage.
     * Updates the internal state and steps array accordingly.
     *
     * @returns {void}
     */
    checkIfAshesDispersalServiceType() {
        // Get the service type name from either the existing booking or local storage
        const serviceTypeFromBooking = !isNil(this.props?.booking?.getServiceTypeName()) ? this.props.booking.getServiceTypeName().toLowerCase() : undefined;
        const serviceTypeFromLocalStorage = !isNil(localStorage?.getItem('service-type-name')) ? localStorage.getItem('service-type-name').toLowerCase() : undefined;

        let isAshesDispersal = false;

        // Check if the service type name is the ashes dispersal service type
        if (!isNil(serviceTypeFromLocalStorage) && !isEmpty(serviceTypeFromLocalStorage)) {
            isAshesDispersal = serviceTypeFromLocalStorage === DISPERSAL_SERVICE_TYPE_NAME;
            this.ashesDespersalServiceTypeName = serviceTypeFromLocalStorage;
        } else if (!isNil(serviceTypeFromBooking) && !isEmpty(serviceTypeFromBooking)) {
            isAshesDispersal = serviceTypeFromBooking === DISPERSAL_SERVICE_TYPE_NAME;
            this.ashesDespersalServiceTypeName = serviceTypeFromBooking;

            // Set the service type name in local storage using the booking data
            localStorage.setItem('service-type-name', serviceTypeFromBooking);
        }

        if (this.isAshesDispersalServiceType !== isAshesDispersal) {
            this.isAshesDispersalServiceType = isAshesDispersal;

            const newSteps = [...this.getStepsArray()];

            this.setState(prevState => ({ ...prevState, steps: newSteps }));
        }
    }

    render() {
        return (
            <div className="main-container">
                <NavbarSecondary />
                <NavbarPrimary />
                <div className="body-content">
                    {
                        this.ashesDespersalServiceTypeName == 'private cremation & dispersal of ashes'
                            ? <PageTitle title={`${this.state.isEdit ? 'Edit' : 'New'} private cremation referral (no ashes return)`} />
                            : <PageTitle title={`${this.state.isEdit ? 'Edit' : 'New'} private cremation referral`} />
                    }
                    {
                        this.props.location.hash && !this.state.isSubmitted
                            ? <Stepper steps={this.state.steps} />
                            : null
                    }
                    {
                        !this.state.isSubmitted
                        ? this.state.isBookingLoaded ? (
                                <ContentCard
                                    className="mt-28"
                                    headerTitle={this.state.headerTitle}
                                    headerStyle={{ paddingBottom: '10px' }}
                                    headerSubComponent={this.headerSubcomponentView()}
                                >
                                    <Container className={ "nb-container " + (this.props.location.hash === REFERRAL_STEPS.confirmation.hash ? 'confirmation-page' : '')}>
                                        {this.stepFormView()}
                                    </Container>
                                </ContentCard>
                            ) : '' : (
                                <BookingSubmitted bookingId={this.state.bookingId} vetDetails={this.state.vetDetails} isUnsubmitted={this.state.isUnsubmitted}/>
                            )
                    }
                </div>
                {
                    !this.state.isSubmitted
                        ? (
                            <FooterBtnActions
                                isEdit={this.state.isEdit}
                                currentPage={this.props.location.hash}
                                showSpinner={this.state.isLoading}
                                nextBtnText={
                                    this.props.location.hash === REFERRAL_STEPS.confirmation.hash
                                        ? this.state.isUnsubmitted ? 'Submit booking' : 'Confirm'
                                        : this.state.isUnsubmitted ? 'Next' : 'Save & Next'
                                }
                                cancelBtnOnCLick={() => this.navigateCancel()}
                                prevBtnOnCLick={() => this.navigatePrev()}
                                nextBtnOnCLick={() => this.onSubmit()}
                            />
                        ) : (
                            <FooterBtnActions
                                nextBtnText="View Booking"
                                nextBtnOnCLick={() => this.onSubmit()}
                            />
                        )
                }
                <AlertDismissible
                    show={this.state.alertFail.show}
                    type="danger"
                    text={this.state.alertFail.message}
                    onClose={() => this.setState({
                        alertFail: {
                            show: false,
                            message: DEFAULT_ERROR_MSG,
                        }
                    })}
                />
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ booking: state.booking });

const mapDispatchToProps = (dispatch) => {
    return {
        updateBooking: (bookingObj) => dispatch(updateBooking(bookingObj)),
        clearBooking: () => dispatch(clearBooking())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PrivateCremation));
